<template>
  <img :src="imgUrl" v-if="hasNodeHidden ? true : imgUrl" @click="imgClick" ref="currentImg" @load="onloadImage" @error="onError" class="wownow-image"  />
</template>

<script>
import storage from '$common/utils/storage';
export default {
  props: {
    src: {
      type: String,
      default: () => ''
    },
    errorImg: {
      type: String,
      default: () => 'https://img.tinhnow.com/wownow/files/pro/app/MEF/BF/BD/aaf6ed3365a94ede86133ccdd140d54e.png'
    },
    hasNodeHidden: {
      type: Boolean,
      default: false
    }
  },
  name: 'wownow-image',
  data() {
    const imgStr = JSON.stringify({
      currentImgSize: 10,
      imgUrl: '',
      loadingImageSrc: '',
      imgWidth: 0,
      imgHeight: 0,
      imgOssPix: 'tinhnow.'
    });
    return {
      imgStr,
      ...JSON.parse(imgStr)
    };
  },
  computed: {
    isOss() {
      return this.src.indexOf(this.imgOssPix) !== -1;
    }
  },
  watch: {
    src(val) {
      this.$root.timeout(() => {
        const newImageObj = JSON.parse(this.imgStr);
        Object.keys(newImageObj).forEach(e => this.$set(this, e, newImageObj[e]));
        this.initImg();
      }, 50);
    }
  },
  mounted() {
    this.initImg();
  },
  methods: {
    onError() {
      if (this.errorImg) {
        this.imgUrl = this.errorImg;
      }
      this.$emit('error');
    },
    //  初始化
    initImg() {
      if (this.src) {
        if (!this.isOss) {
          this.$set(this, 'imgUrl', this.src);
        } else {
          const cacheImg = storage.getItem(`wownow-image-${this.src}`);
          this.$set(this, 'loadingImageSrc', this.src);
          if (cacheImg && cacheImg.url && cacheImg.imgWidth && cacheImg.currentImgSize) {
            this.$set(this, 'imgUrl', cacheImg.url);
            this.$set(this, 'imgWidth', cacheImg.imgWidth);
            this.$set(this, 'currentImgSize', cacheImg.currentImgSize);
            return;
          }

          this.getBackgroundImg();
        }
      }
    },
    //  获取 img 标签的宽高
    getImgSize() {
      if (this.$refs.currentImg) {
        if (!this.imgWidth || !this.imgHeight) {
          this.imgWidth = this.$root.getWidth(this.$refs.currentImg);
          this.imgHeight = this.$root.getHeight(this.$refs.currentImg);
        }
        this.getHDPictures();
      }
    },
    //  获取高清的图片
    getHDPictures() {
      if (this.currentImgSize === 10) {
        this.downLoadingImg(this.getImgUrl({ currentImgSize: this.imgWidth })).then((__url) => {
          if (this.currentImgSize < this.imgWidth) {
            this.currentImgSize = this.imgWidth;
            storage.setItem(`wownow-image-${this.src}`, {
              url: __url,
              imgWidth: this.imgWidth,
              currentImgSize: this.currentImgSize
            });
            this.imgUrl = __url;
          }
        });
      } else if (this.currentImgSize < parseInt(this.imgWidth * 2, 10)) {
        this.downLoadingImg(this.getImgUrl({ currentImgSize: parseInt(this.imgWidth * 2, 10) })).then((__url) => {
          this.currentImgSize = parseInt(this.imgWidth * 2, 10);
          storage.setItem(`wownow-image-${this.src}`, {
            url: __url.split('?')[0],
            imgWidth: this.imgWidth,
            currentImgSize: this.currentImgSize
          });
          this.imgUrl = __url.split('?')[0];
        });
      }
    },
    //  初始化获取头张宽度 10px 的图片
    onloadImage() {
      const __timeout = setTimeout(() => {
        clearTimeout(__timeout);
        if (!this.isOss || this.isOss && this.imgWidth && this.currentImgSize > (parseInt(this.imgWidth / 2, 10) + this.imgWidth)) {
          this.getImgSize();
          return this.$emit('load', {
            width: this.imgWidth,
            height: this.imgHeight
          });
        }
        if (this.currentImgSize === 10 || this.currentImgSize < parseInt(this.imgWidth * 2, 10)) {
          this.getImgSize();
        }
      }, 50);
    },
    //  获取指定宽度的图片
    getImgUrl(params = {}) {
      const { currentImgSize = this.currentImgSize } = params;
      return `${this.loadingImageSrc}?x-oss-process=image/resize,w_${parseInt(currentImgSize, 10)},m_lfit`;
    },
    //  预加载图片
    downLoadingImg(__url) {
      return new Promise((resolve, reject) => {
        const url = !!__url.split('?')[0] ? __url : this.errorImg;
        const img = new Image();
        img.src = url;
        img.onload = () => resolve(url);
        img.onerror = () => reject(url);
      });
    },
    //  赋值图片带参地址
    getBackgroundImg() {
      this.imgUrl = this.getImgUrl();
    },
    imgClick() {
      this.$emit('click');
    }
  }
}
</script>

<style lang="stylus" scoped>
  .wownow-image {
    font-size: 0;
  }
</style>
